export enum StreamRequestStatus {
  None = 'none',
  Upcoming = 'upcoming',
  Cancelled = 'cancelled',
  Live = 'live',
  Stopped = 'stopped',
  Ended = 'ended',
  Replay = 'replay',
  Highlights = 'highlights'
}
